import { render, staticRenderFns } from "./UserOtherInterestDelete.vue?vue&type=template&id=b84b6f16&"
import script from "./UserOtherInterestDelete.vue?vue&type=script&lang=js&"
export * from "./UserOtherInterestDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports